import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  isMobileSessionUnlocked,
  isNativeFeaturePath,
  isNativeMobileApp,
  MOBILE_APP_HOME_PATH,
  MOBILE_APP_LOGIN_PATH,
} from '../../utils/mobileApp';
import { attachMobilePushListeners } from '../../utils/mobilePushNotifications';
import MobileInAppChrome from '../mobile/MobileInAppChrome';

/** Trong APK chỉ cho phép shell app (đăng nhập + 4 tab). Các trang web khác chuyển về app. */
const NativeMobileRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isNativeMobileApp()) return;
    void attachMobilePushListeners();
  }, []);

  if (!isNativeMobileApp()) {
    return <>{children}</>;
  }

  const path = location.pathname;
  const unlocked = isMobileSessionUnlocked();

  if (path === MOBILE_APP_LOGIN_PATH) {
    return <>{children}</>;
  }

  if (path === MOBILE_APP_HOME_PATH) {
    if (!unlocked) {
      return <Navigate to={MOBILE_APP_LOGIN_PATH} replace />;
    }
    return <>{children}</>;
  }

  if (unlocked && isAuthenticated && isNativeFeaturePath(path)) {
    return <MobileInAppChrome>{children}</MobileInAppChrome>;
  }

  return (
    <Navigate
      to={isAuthenticated && unlocked ? MOBILE_APP_HOME_PATH : MOBILE_APP_LOGIN_PATH}
      replace
    />
  );
};

export default NativeMobileRouteGuard;
